@if (apiLoaded | async) {
  <div>
    <google-map
      [options]="mapOptions"
      [zoom]="mapOptions.zoom"
      [center]="mapOptions.center"
      [width]="mapOptions.width"
      [height]="mapOptions.height"
      >
      @for (marker of markers; track marker) {
        <map-marker
          [position]="marker.position"
          [label]="marker.label"
          [title]="marker.title"
          [options]="marker.options"
        ></map-marker>
      }
    </google-map>
  </div>
}
